
import ReactDOM from 'react-dom';

export function mountApp(appComponent: JSX.Element) {
    document.addEventListener('DOMContentLoaded', async () => {
        const hostEl = document.createElement('div');
        hostEl.setAttribute('id', 'root');
        ReactDOM.render(
            appComponent,
            document.body.appendChild(hostEl),
        )
    })
}
